module.exports = __webpack_public_path__ + "static/media/qr.ed753791.svg";